import { apiFuns } from "sw-hic";
let { genStandard } = apiFuns;
let api = {
  TenantApply: genStandard("tenantApply", "/api/md"),
  Tenant: genStandard("tenant", "/api/md"),
};
export default api;
